import apiClient from '../lib/api-client';

export interface NotificationPreferences {
  examReminders?: boolean;
  progressUpdates?: boolean;
  newsletter?: boolean;
}

export interface UserPreferences {
  language?: string;
  targetLevel?: string;
  focusAreas?: string[];
  studyGoal?: string;
  weeklyGoal?: number;
  notifications?: NotificationPreferences;
}

export interface User {
  id: string;
  email: string;
  name: string;
  role: string;
  emailVerified?: boolean;
  preferences?: UserPreferences;
  subscription?: {
    plan?: string;
    status?: string;
    currentPeriodEnd?: string;
  };
  passTier?: string | null;
  passStartedAt?: string | null;
  passExpiresAt?: string | null;
  passActive?: boolean;
  statistics?: {
    examsTaken: number;
    examsCompleted?: number;
    averageScore?: number;
    currentStreak: number;
    studyStreak?: number;
    longestStreak?: number;
    totalStudyTime: number;
    lastActiveDate?: string;
  };
  createdAt?: string;
  updatedAt?: string;
}

export interface UpdateProfileDto {
  name?: string;
}

export interface UpdatePreferencesDto {
  language?: string;
  notifications?: NotificationPreferences;
}

export interface ChangePasswordDto {
  currentPassword: string;
  newPassword: string;
}

export const userService = {
  async getProfile() {
    const response = await apiClient.get<User>('/users/me');
    return response.data;
  },

  async updateProfile(data: UpdateProfileDto) {
    const response = await apiClient.put<{ message: string; user: User }>(
      '/users/me',
      data
    );
    return response.data;
  },

  async updatePreferences(data: UpdatePreferencesDto) {
    const response = await apiClient.put<{
      message: string;
      preferences: UserPreferences;
    }>('/users/me/preferences', data);
    return response.data;
  },

  async changePassword(data: ChangePasswordDto) {
    const response = await apiClient.put<{ message: string }>(
      '/users/me/password',
      data
    );
    return response.data;
  },

  async getStatistics() {
    const response = await apiClient.get<User['statistics']>('/users/me/stats');
    return response.data;
  },
};
